/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{ShaderOutputConfiguration as o}from"../ShaderOutputConfiguration.js";class s extends o{constructor(){super(...arguments),this.instancedDoublePrecision=!1,this.hasModelTransformation=!1}}export{s as InstancedDoubleConfiguration};
